<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="main-card" flat>

            <v-tabs v-model="tabs" background-color="transparent" centered grow show-arrows slider-color="transparent"
                class="custom-tabs">

                <!-- Personal -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_personal') !== -1"
                    :class="['custom-tab', 'first-tab', { 'active-tab': tabs === 0 }]">
                    <v-icon class="mr-2">mdi-account</v-icon>Personal
                </v-tab>

                <!-- Parent Details -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_parent_details') !== -1"
                    :class="['custom-tab', { 'active-tab': tabs === 1 }]">
                    <v-icon class="mr-2">mdi mdi-human-male-female-child</v-icon>Parent Details
                </v-tab>

                <!-- Birth Details -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_birth_details') !== -1"
                    :class="['custom-tab', { 'active-tab': tabs === 2 }]">
                    <v-icon class="mr-2">mdi mdi-cake-variant</v-icon>Birth Details
                </v-tab>

                <!-- Sibling Details -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_sibling_details') !== -1"
                    :class="['custom-tab', { 'active-tab': tabs === 3 }]">
                    <v-icon class="mr-2">mdi-human-child</v-icon>Sibling Details
                </v-tab>

                <!-- Category Details -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_category_details') !== -1"
                    :class="['custom-tab', 'last-tab', { 'active-tab': tabs === 4 }]">
                    <v-icon class="mr-2">mdi mdi-view-grid-outline</v-icon>Category Details
                </v-tab>

                <!-- Physically Challenged -->
                <v-tab v-if="profile_relative_tab.indexOf('Under_basic_tab_physically_challenged') !== -1"
                    :class="['custom-tab', 'last-tab', { 'active-tab': tabs === 5 }]">
                    <v-icon class="mr-2">mdi-wheelchair-accessibility</v-icon>Physically Challenged
                </v-tab>

            </v-tabs>

            <v-tabs-items v-model="tabs">
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_personal') !== -1">
                    <v-card flat>
                        <v-row class="pa-5">
                            <template v-for="field in fields">
                                <v-col v-if="field.isactive" cols="12" sm="3" md="3" class="pt-0 pb-0">

                                    <!-- Label except for checkboxes -->
                                    <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2"
                                        style="font-size: 14px;">
                                        <b>{{ field.label }}<span v-if="field.required" class="pl-1"
                                                style="color:red">*</span></b>
                                    </div>
                                    <!-- For editable text fields (excluding some) -->
                                    <v-text-field
                                        v-if="field.input_type === 'text' && field.field_name !== 'registration_no' && field.field_name !== 'standard' && field.field_name !== 'division' && field.field_name !== 'roll_no'"
                                        v-model.trim="field.value" :readonly="!field.iseditable"
                                        :filled="!field.iseditable" dense outlined rounded />

                                    <!-- For readonly fixed fields -->
                                    <v-text-field
                                        v-if="field.field_name === 'registration_no' || field.field_name === 'standard' || field.field_name === 'division' || field.field_name === 'roll_no'"
                                        v-model.trim="field.value" readonly filled dense outlined rounded />


                                    <!-- Number -->
                                    <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value"
                                        type="number" :readonly="!field.iseditable" :filled="!field.iseditable" dense
                                        outlined rounded />

                                    <!-- Date -->
                                    <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        type="date" />

                                    <!-- Checkbox -->

                                    <div v-if="field.input_type === 'checkbox'" class="d-flex align-center pt-5">
                                        <v-checkbox v-model="field.value" :label="field.label"
                                            :readonly="!field.iseditable" density="compact" class="font-weight-bold" />
                                        <span v-if="field.required" class="pl-1" style="color:red">*</span>
                                    </div>

                                    <!-- Select -->
                                    <v-select
                                        v-if="field.input_type === 'select' && !field.multiple && (field.field_name !== 'admission_year')"
                                        v-model="field.value" item-text="name" item-value="id" :items="field.options"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                        rounded />

                                    <v-select v-if="field.field_name === 'admission_year' && !field.multiple"
                                        v-model="field.value" item-text="name" item-value="id" :items="field.options"
                                        hint="Changing admission year may change your fee structure" persistent-hint
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                        rounded />

                                    <v-autocomplete v-if="field.input_type === 'select' && field.multiple"
                                        v-model="field.value" :items="field.options" :multiple="true"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" :clearable="true"
                                        dense single-line rounded outlined />
                                </v-col>
                            </template>
                            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>First Name</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.firstname" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Middle Name</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.middle_name" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Last Name</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.last_name" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Full Name</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.full_name" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Name As Per Aadhar</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.name_as_per_adhar" outlined rounded
                                    dense></v-text-field>
                            </v-col> -->
                            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Gender</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.gender" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Blood Group</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.blood_group" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Date of Birth</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.date_of_birth" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Date of Birth In Words</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.date_of_birth_in_world" outlined
                                    rounded dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>GR No.</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.gr_no" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>PEN No.</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.pen_no" outlined rounded
                                    dense></v-text-field>
                            </v-col> -->
                            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Saral ID</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.saral_id" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>APAAR ID</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.apaar_id" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Birth Place</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.birth_place" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Nationality / Citizenship</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.nationality" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Grade</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.grade" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Division</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.division" outlined rounded
                                    dense></v-text-field>
                            </v-col> -->
                            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Roll No.</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.roll_no" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>School Medium</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.school_medium" outlined rounded
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>House</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.house" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Date of Admission</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.date_of_admission" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Admission Year</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.admission_year" outlined rounded
                                    dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Date of Physically Attended</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.date_of_physically_Attended"
                                    outlined rounded dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-2" style="font-size: 14px;"><b>Student Type</b></div>
                                <v-text-field readonly filled v-model.trim="readonly.student_type" outlined rounded
                                    dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <span class="pl-1 pb-2" style="font-size: 14px;"><b>Aadhar No.</b></span><v-icon
                                    class="pl-1 pb-2" color="error">*</v-icon>
                                <v-text-field rounded outlined dense v-model="editable.adhar_no" type="number"
                                    :rules="[v => (v && v.toString().length === 12) || 'Aadhar No. must be exactly 12 digits']"
                                    name="adhar_no"></v-text-field>
                            </v-col> -->


                            <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <span class="pl-1 pb-2" style="font-size: 14px;"><b>Mother Tongue</b></span><v-icon
                                    class="pl-1 pb-2" color="error">*</v-icon>
                                <v-select v-model="editable.mother_tongue" :items="language_list" persistent-hint
                                    outlined rounded dense>
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <span class="pl-1 pb-2" style="font-size: 14px;"><b>Languages Spoken</b></span><v-icon
                                    class="pl-1 pb-2" color="error">*</v-icon>
                                <v-select v-model="languagesSpoken" :items="language_list" single-line :clearable="true"
                                    persistent-hint outlined rounded dense multiple>
                                </v-select>
                            </v-col>

                            <v-col cols=" 12" sm="3" md="3" class="pt-0 pb-0">
                                <span class="pl-1 pb-2" style="font-size: 14px;"><b>Family Type</b></span><v-icon
                                    class="pl-1 pb-2" color="error">*</v-icon>
                                <v-select v-model="editable.family_type" :items="family_type_list" persistent-hint
                                    outlined rounded dense>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <div class="pl-1 pb-1" style="font-size: 14px;">
                                    <b>Family Income in Rs.</b>
                                    <v-icon color="error" class="pl-1 pb-2">*</v-icon>
                                </div>
                                <v-text-field v-model.trim="editable.family_income_in_rs"
                                    :readonly="!editable.edit_family_income" :filled="!editable.edit_family_income"
                                    outlined rounded dense type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                                <span style="font-size: 14px;"><b>Is Single Parent ?<v-icon class="pl-1 pb-2"
                                            color="error">*</v-icon></b></span>
                                <v-radio-group v-model="editable.is_single_parent" mandatory row class="no-display">
                                    <v-radio label="No" :value="false" color="#0f2027"></v-radio>
                                    <v-radio label="Yes" :value="true" color="#0f2027"></v-radio>
                                </v-radio-group>
                            </v-col> -->
                        </v-row>
                        <v-row dense justify="center">
                            <v-btn @click="savePersonal()" :loading="save_loader" text class="button-77">Save</v-btn>
                        </v-row>
                        <br>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_parent_details') !== -1">
                    <v-card>
                        <!-- Father Details Section -->
                        <v-toolbar class="custom-toolbar ma-2" flat dense>
                            <v-toolbar-title>Father Details</v-toolbar-title>
                        </v-toolbar>
                        <v-row dense class="px-5">
                            <!-- Only render fields if parentDetails.father.fields exists and is an array -->
                            <template v-if="parentDetails.father && Array.isArray(parentDetails.father.fields)">
                                <v-col v-for="field in parentDetails.father.fields" :key="field.field_name"
                                    v-if="field.isactive && field.input_type !== 'file' && !field.field_name.endsWith('_relative_photo_file')"
                                    cols="12" sm="3" md="3" class="pt-0 pb-0">
                                    <!-- Label for non-checkbox fields -->
                                    <div class="pl-1 pb-2" style="font-size: 14px;">
                                        <b>{{ field.label }}<span v-if="field.required" class="pl-1"
                                                style="color:red">*</span></b>
                                    </div>
                                    <!-- Text Field -->
                                    <!-- <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        @keypress="blockNonLetters" /> -->
                                    <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        :rules="getTextFieldRules(field)" />
                                    <!-- Number Field -->
                                    <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value"
                                        type="number" :readonly="!field.iseditable" :filled="!field.iseditable" dense
                                        outlined rounded :rules="getNumberFieldRules(field.field_name, field.required)"
                                        @keypress="restrictToNumbers" />
                                    <!-- Date Field -->
                                    <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        type="date" />
                                    <!-- Select Field -->
                                    <v-select v-if="field.input_type === 'select' && !field.multiple"
                                        v-model="field.value" :items="field.options" :readonly="!field.iseditable"
                                        :filled="!field.iseditable" dense outlined rounded />
                                    <!-- Email Field -->
                                    <v-text-field v-if="field.input_type === 'email'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        :rules="emailRules" />
                                </v-col>
                            </template>
                            <v-col cols="12" sm="12" md="12" align="center">
                                <v-btn :loading="save_loader" @click="saveParentData('Father')" text
                                    class="button-77">Save</v-btn>
                            </v-col>
                        </v-row>
                        <br>
                        <!-- Father's Photo Section -->
                        <v-toolbar class="custom-toolbar ma-2" flat dense>
                            <v-toolbar-title>Father's Photo</v-toolbar-title>
                        </v-toolbar>
                        <v-row v-if="parentDetails.father && Array.isArray(parentDetails.father.fields) &&
    parentDetails.father.fields.some(f => f.field_name === 'father_relative_photo_file' && f.isactive)">
                            <!-- Info Box -->
                            <v-col cols="12" sm="5" md="5" class="pl-7" align-self="right">
                                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                                    <b class="pl-6">Photo Upload Instructions : </b>
                                    <ul>
                                        <li>Photo should be in .jpg/.png format only.</li>
                                        <li>Resolution should be W=350px, H=450px. Photo size should be ≤ 500KB.</li>
                                    </ul>
                                </div>
                                <!-- File Input -->
                                <div class="pt-4">
                                    <span class="pl-8 pb-2" style="font-size: 14px;">
                                        <b>Father Photo</b>
                                        <v-icon v-if="parentDetails.father.fields.find(f => f.field_name === 'father_relative_photo_file') &&
            parentDetails.father.fields.find(f => f.field_name === 'father_relative_photo_file').required"
                                            class="pl-1 pb-2" color="error">*</v-icon>
                                    </span>
                                    <v-file-input v-model="parentDetails.father.photo" label="Select Father Photo File"
                                        prepend-icon="mdi-camera" show-size outlined accept="image/jpeg, image/png"
                                        :rules="[() => photoValidationError === '' || photoValidationError]"
                                        @change="validateFatherPhoto" 
                                         :disabled="!parentDetails.father.fields.find(f => f.field_name === 'father_relative_photo_file').iseditable"/>
                                    <!-- <v-alert
        v-if="photoValidationError"
        type="error"
        dense
        class="mt-2"
      >
        {{ photoValidationError }}
      </v-alert> -->
                                </div>
                            </v-col>
                            <!-- Placeholder for Preview -->
                            <v-col cols="12" sm="3" md="3" class="pl-10 ml-2 pr-0" align="center">
                                <span><b>Selected Photo</b></span>
                                <div style="border: 1px solid black; width: 185px; height: 190px;">
                                    <img v-if="previewFatherPhoto" :src="previewFatherPhoto" width="180" height="180" />
                                </div>
                            </v-col>
                            <!-- Existing Father Photo -->
                            <v-col cols="12" sm="3" md="3" class="pl-10 ml-2 pr-0" align="center"
                                v-if="parentDetails.father.old_photo">
                                <span><b>Previous Photo</b></span>
                                <div style="border: 1px solid black; width: 185px; height: 190px;">
                                    <img :src="parentDetails.father.old_photo" width="180" height="180" />
                                </div>
                            </v-col>
                            <!-- Upload Button -->
                            <v-col cols="12" align="center">
                                <v-btn @click="saveParentData('Father_Upload')" :loading="save_loader" text
                                    class="button-77">
                                    Upload Photo
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-5" color="navy"></v-divider>
                        <br>
                        <!-- Mother Details Section -->
                        <v-toolbar class="custom-toolbar ma-2" flat dense>
                            <v-toolbar-title>Mother Details</v-toolbar-title>
                        </v-toolbar>
                        <v-row dense class="px-5">
                            <!-- Only render fields if parentDetails.mother.fields exists and is an array -->
                            <template v-if="parentDetails.mother && Array.isArray(parentDetails.mother.fields)">
                                <v-col v-for="field in parentDetails.mother.fields" :key="field.field_name"
                                    v-if="field.isactive && field.input_type !== 'file' && !field.field_name.endsWith('_relative_photo_file')"
                                    cols="12" sm="3" md="3" class="pt-0 pb-0">
                                    <!-- Label for non-checkbox fields -->
                                    <div class="pl-1 pb-2" style="font-size: 14px;">
                                        <b>{{ field.label }}<span v-if="field.required" class="pl-1"
                                                style="color:red">*</span></b>
                                    </div>
                                    <!-- Text Field -->
                                    <!-- <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        @keypress="blockNonLetters" /> -->
                                    <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        :rules="getTextFieldRules(field)" />
                                    <!-- Number Field -->
                                    <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value"
                                        type="number" :readonly="!field.iseditable" :filled="!field.iseditable" dense
                                        outlined rounded :rules="getNumberFieldRules(field.field_name, field.required)"
                                        @keypress="restrictToNumbers" />
                                    <!-- Date Field -->
                                    <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        type="date" />
                                    <!-- Select Field -->
                                    <v-select v-if="field.input_type === 'select' && !field.multiple"
                                        v-model="field.value" :items="field.options" :readonly="!field.iseditable"
                                        :filled="!field.iseditable" dense outlined rounded />
                                    <!-- Email Field -->
                                    <v-text-field v-if="field.input_type === 'email'" v-model.trim="field.value"
                                        :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded
                                        :rules="emailRules" />
                                </v-col>
                            </template>
                            <v-col cols="12" sm="12" md="12" align="center">
                                <v-btn :loading="save_loader" text class="button-77"
                                    @click="saveParentData('Mother')">Save</v-btn>
                            </v-col>
                        </v-row>
                        <br>
                        <!-- Mother's Photo Section -->
                        <v-toolbar class="custom-toolbar ma-2" flat dense>
                            <v-toolbar-title>Mother's Photo</v-toolbar-title>
                        </v-toolbar>
                        <v-row v-if="parentDetails.mother && Array.isArray(parentDetails.mother.fields) &&
    parentDetails.mother.fields.some(f => f.field_name === 'mother_relative_photo_file' && f.isactive)">
                            <v-col cols="12" sm="5" md="5" class="pl-7" align-self="right">
                                <div style="border: 1px solid orange; color: orange; border-radius: 20px;" class="pa-2">
                                    <b class="pl-6">Photo Upload Instructions : </b>
                                    <ul>
                                        <li>Photo should be in .jpg/.png format only.</li>
                                        <li>Resolution should be W=350px, H=450px. Photo size should be ≤ 500KB.</li>
                                    </ul>
                                </div>
                                <div class="pt-4">
                                    <span class="pl-8 pb-2" style="font-size: 14px;">
                                        <b>Mother Photo</b>
                                        <v-icon v-if="parentDetails.mother.fields.find(f => f.field_name === 'mother_relative_photo_file') &&
            parentDetails.mother.fields.find(f => f.field_name === 'mother_relative_photo_file').required"
                                            class="pl-1 pb-2" color="error">*</v-icon>
                                    </span>
                                    <v-file-input label="Select Mother Photo File" prepend-icon="mdi-camera" show-size
                                        outlined v-model="parentDetails.mother.photo" @change="validateMotherPhoto"
                                        :rules="[() => photoValidationErrorMother === '' || photoValidationErrorMother]"
                                        accept="image/jpeg, image/png" 
                                        :disabled="!parentDetails.mother.fields.find(f => f.field_name === 'mother_relative_photo_file').iseditable"/>
                                    <!-- <v-alert
        v-if="photoValidationErrorMother"
        type="error"
        dense
        class="mt-2"
      >
        {{ photoValidationErrorMother }}
      </v-alert> -->
                                </div>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pl-10 ml-2 pr-0" align="center">
                                <span><b>Selected Photo</b></span>
                                <div style="border: 1px solid black; width: 185px; height: 190px;">
                                    <img v-if="previewMotherPhoto" :src="previewMotherPhoto" width="180" height="180" />
                                </div>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pl-10 ml-2 pr-0" align="center"
                                v-if="parentDetails.mother.old_photo">
                                <span><b>Previous Photo</b></span>
                                <div style="border: 1px solid black; width: 185px; height: 190px;">
                                    <img :src="parentDetails.mother.old_photo" width="180" height="180" />
                                </div>
                            </v-col>
                            <v-col cols="12" align="center">
                                <v-btn @click="saveParentData('Mother_Upload')" :loading="save_loader" text
                                    class="button-77">
                                    Upload Photo
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-tab-item>

                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_birth_details') !== -1">
                    <v-card flat>
                        <v-row dense class="pa-5">
                            <v-col v-for="(field, key) in birthDetails" :key="key" v-if="field && field.isactive"
                                cols="12" sm="3" md="3" class="pt-0">
                                <!-- Label -->
                                <span class="pl-1 pb-2" style="font-size: 14px;">
                                    <b>{{ field.displayName }}</b>
                                </span>
                                <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>

                                <!-- Input -->
                                <v-text-field v-if="field.type === 'text'" v-model.trim="field.value" outlined dense
                                    rounded :disabled="!field.iseditable"
                                    @keypress="allowOnlyText($event)"></v-text-field>

                                <v-select v-else-if="field.type === 'select'" v-model="field.value"
                                    :items="birthcountry_list" outlined rounded dense
                                    :disabled="!field.iseditable"></v-select>
                            </v-col>

                            <!-- Save Button -->
                            <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
                                <v-btn text class="button-77" :loading="birth_loader"
                                    @click="saveBirthDetails">Save</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_sibling_details') !== -1">
                    <v-card flat>
                        <br>
                        <div class="sibling-table-container">
                            <table class="sibling-table">
                                <thead>
                                    <!-- <tr>
                                        <th class="custom-header">Sr.No.</th>
                                        <th class="custom-header">Name</th>
                                        <th class="custom-header">Relationship With Child</th>
                                        <th class="custom-header">Date of Birth</th>
                                        <th class="custom-header">School Name</th>
                                        <th class="custom-header">Standard</th>
                                    </tr> -->
                                </thead>
                                <tbody>
                                    <!-- Sibling 1 -->
                                    <tr v-if="sibling1 != null">
                                        <td>1
                                            <input type="hidden" name="sib1_id" :value="sibling1.sib_id1" />
                                        </td>

                                        <td v-for="field in fields1" :key="field.model" v-if="field.isactive">
                                            <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2"
                                                style="font-size: 14px;">
                                                <b>{{ field.label }}<span v-if="field.required" class="pl-1"
                                                        style="color:red">*</span></b>
                                            </div>

                                            <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                                :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                                rounded @input="onlyLettersAndSpace(field)"
                                                @keydown="restrictToLettersOnly($event)"
                                                @paste.prevent="cleanPaste(field)" :rules="lettersOnlyRules"
                                                hint="Only alphabets and spaces allowed" persistent-hint />

                                            <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value"
                                                :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                                rounded type="date" />

                                            <v-select v-if="field.input_type === 'select' && !field.multiple"
                                                v-model="field.value" :items="field.options" item-text="name"
                                                item-value="name" :readonly="!field.iseditable"
                                                :filled="!field.iseditable" dense outlined rounded />
                                        </td>
                                    </tr>

                                    <!-- Sibling 2 -->
                                    <tr v-if="sibling2 != null">
                                        <td>2
                                            <input type="hidden" name="sib2_id" :value="sibling2.sib_id2" />
                                        </td>

                                        <td v-for="field in fields2" :key="field.model" v-if="field.isactive">
                                            <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2"
                                                style="font-size: 14px;">
                                                <b>{{ field.label }}<span v-if="field.required" class="pl-1"
                                                        style="color:red">*</span></b>
                                            </div>
                                            <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value"
                                                :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                                rounded @input="onlyLettersAndSpace(field)"
                                                @keydown="restrictToLettersOnly($event)"
                                                @paste.prevent="cleanPaste(field)" :rules="lettersOnlyRules"
                                                hint="Only alphabets and spaces allowed" persistent-hint />

                                            <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value"
                                                :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
                                                rounded type="date" />

                                            <v-select v-if="field.input_type === 'select' && !field.multiple"
                                                v-model="field.value" :items="field.options" item-text="name"
                                                item-value="name" :readonly="!field.iseditable"
                                                :filled="!field.iseditable" dense outlined rounded />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
                            <v-btn text class="button-77" :loading="sibling_loader"
                                @click="saveSiblingProfile">Save</v-btn>
                        </v-col>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_category_details') !== -1">
                    <v-card flat>
                        <v-row dense class="pa-5">
                            <!-- Dynamic Text / Select Fields -->
                            <v-col v-for="(field, key) in CategoryDetails" :key="key"
                                v-if="field && field.isactive && field.type !== 'file'" cols="12" sm="3" md="3"
                                class="pt-0">
                                <!-- Label -->
                                <span class="pl-1 pb-2" style="font-size: 14px;">
                                    <b>{{ field.displayName }}</b>
                                </span>
                                <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>

                                <!-- Input -->
                                <v-text-field v-if="field.type === 'text'" v-model.trim="field.value" outlined dense
                                    rounded :disabled="!field.iseditable"></v-text-field>

                                <v-select v-if="field.type === 'select' && field.displayName != 'Quota'"
                                    v-model="field.value" :items="getItemsForField(key)" outlined rounded dense
                                    :disabled="!field.iseditable"></v-select>

                                <v-select v-if="field.displayName === 'Quota'" v-model="field.value" item-text="name"
                                    item-value="id" :items="getItemsForField(key)"
                                    hint="Changing quota may change your fee structure" persistent-hint
                                    :disabled="!field.iseditable" outlined dense rounded />
                            </v-col>

                            <!-- File Upload (Caste Certificate) -->
                            <v-col cols="12" sm="4" md="4" class="pt-0"
                                v-if="CategoryDetails.cast_certificate && CategoryDetails.cast_certificate.isactive">
                                <span class="pl-1 pb-2" style="font-size: 14px;">
                                    <b>{{ CategoryDetails.cast_certificate.displayName }}</b>
                                </span>
                                <v-icon v-if="CategoryDetails.cast_certificate.required" class="pl-1 pb-2"
                                    color="error">*</v-icon>

                                <v-file-input dense rounded outlined v-model="CategoryDetails.cast_certificate.newFile"
                                    placeholder="Upload Caste Certificate" label="Document" prepend-icon="mdi-upload"
                                    show-size :disabled="!CategoryDetails.cast_certificate.iseditable">
                                    <template v-slot:selection="{ text }">
                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                    </template>
                                </v-file-input>

                                <v-btn v-if="CategoryDetails.cast_certificate.newFile"
                                    :color="CategoryDetails.cast_certificate.newFile ? 'primary darken-1' : 'grey lighten-1'"
                                    @click="uploadCasteCertificate"
                                    :disabled="!CategoryDetails.cast_certificate.newFile"
                                    :loading="upload_image_loader">
                                    <v-icon dark>mdi-cloud-upload</v-icon> Upload
                                </v-btn>
                            </v-col>
                            <!-- Existing File Preview -->
                            <v-col cols="12" sm="2" md="2" class="pt-0 pb-0 px-0"
                                v-if="CategoryDetails.cast_certificate && CategoryDetails.cast_certificate.value">
                                <div>
                                    <v-btn text color="primary" icon title="Download">
                                        <a :href="awspath + CategoryDetails.cast_certificate.value.path" target="_blank"
                                            style="text-decoration: none;">
                                            <v-icon>mdi-file-download</v-icon>
                                        </a>
                                    </v-btn>
                                    <v-btn text title="Delete File" :loading="delete_load"
                                        :disabled="!CategoryDetails.cast_certificate.iseditable"
                                        @click="deleteAttachment(CategoryDetails.cast_certificate.value.id)">
                                        <v-icon color="red">mdi-window-close</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>

                            <!-- Save Button -->
                            <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
                                <v-btn text class="button-77" :loading="category_loader"
                                    @click="saveChildCategoryDetails">
                                    Save
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-tab-item>
                <v-tab-item v-if="profile_relative_tab.indexOf('Under_basic_tab_physically_challenged') !== -1">
                    <v-card flat>
                        <v-row dense class="pa-5">

                            <v-col v-for="(field, key) in PhysicallyChallenged" :key="key" v-if="field && field.isactive && (
                                key === 'is_physically_disabled' || PhysicallyChallenged.is_physically_disabled.value === true
                            )" cols="12" sm="4" md="4" class="pt-0">

                                <!-- Label -->
                                <span class="pl-1 pb-2" style="font-size: 14px;">
                                    <b>{{ field.displayName }}</b>
                                </span>
                                <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>

                                <!-- Checkbox -->
                                <v-checkbox v-if="field.type === 'checkbox'" v-model="field.value"
                                    :readonly="!field.iseditable" density="compact" class="font-weight-bold" />

                                <!-- Text input -->
                                <v-text-field v-else-if="field.type === 'text'" v-model.trim="field.value" outlined
                                    dense rounded :disabled="!field.iseditable" />

                                <!-- Select dropdown -->
                                <v-select v-else-if="field.type === 'select'" v-model="field.value"
                                    :items="disability_type_list" outlined rounded dense
                                    :disabled="!field.iseditable" />
                            </v-col>
                            <!-- Save Button -->
                            <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
                                <v-btn text class="button-77" :loading="disability_loader"
                                    @click="saveChildDisabilityDetails">
                                    Save
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-card>
                </v-tab-item>


            </v-tabs-items>

        </v-card>
    </div>
</template>

<script>
    import UnderDevelopement from "@/components/shared/UnderDevelopement.vue";
    import axios from "axios";

    export default {
        props: {
            learner: {
                type: [String, Number], // Adjust type based on your actual value
                required: true
            },
            profile_relative_tab: {
                type: Array,
                default: () => []
            }
        },
        components: { UnderDevelopement },
        data() {
            return {
                tabs: 0,
                ldid: null,
                photoValidationError: '',
                photoValidationErrorMother: '',
                previewFatherPhoto: '',
                previewMotherPhoto: '',
                awspath: null,
                emailRules: [
                    v => !!v || 'Email is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
                color: "",
                snackbar: false,
                snackbar_msg: "",
                edit_loader: false,
                save_loader: false,
                family_type_list: [],
                birthcountry_list: [],
                language_list: [],
                fields: [],
                learner_id: "",
                readonly: {
                    registration_number: '',
                    firstname: '',
                    middle_name: '',
                    last_name: '',
                    full_name: '',
                    name_as_per_adhar: '',
                    student_name_as_per_doc: '',
                    gender: '',
                    blood_group: '',
                    date_of_birth: '',
                    date_of_birth_in_world: '',
                    gr_no: '',
                    pen_no: '',
                    saral_id: '',
                    apaar_id: '',
                    birth_place: '',
                    nationality: '',
                    grade: '',
                    division: '',
                    roll_no: '',
                    school_medium: '',
                    house: '',
                    date_of_admission: '',
                    admission_year: '',
                    date_of_physically_Attended: '',
                    student_type: '',

                },
                editable: {
                    learner_id: '',
                    adhar_no: '',
                    mother_tongue: '',
                    languages_spoken: '',
                    is_single_parent: false,
                    family_type: '',
                    family_income_in_rs: '',
                },
                parentDetails: {
                    learner_id: '',
                    mother: {
                        present: false,
                        fields: [], // Initialize as empty array
                        photo: null,
                        old_photo: null
                    },
                    father: {
                        present: false,
                        fields: [], // Initialize as empty array
                        photo: null,
                        old_photo: null
                    }
                },
                birthDetails: {},
                CategoryDetails: {
                    learner_id: '',
                    quota: '',
                    category: '',
                    domacile: '',
                    religion: '',
                    cast: '',
                    sub_caste: '',
                    cast_cert: null
                },
                PhysicallyChallenged: {
                    learner_id: '',
                    is_physically_disabled: false,
                    disability_details: null,
                    disability_percentage: ''
                },
                domacile_list: [],
                cast_list: [],
                CategoryDetails: [],
                religion_list: [],
                sibling1: {},
                sibling2: {},
                standard_list: [],
                relationtype_list: [
                    "Brother", "Sister"
                ],
                lettersOnlyRules: [
                    v => !!v || 'This field is required',
                    v => /^[A-Za-z\s]*$/.test(v) || 'Only letters and spaces are allowed',
                    v => (v && v.trim() !== '') || 'Name cannot be empty'
                ],
                sub_cast_list: [],
                delete_load: false,
                stud_data: "",
                disability_type_list: [],
                birth_loader: false,
                category_loader: false,
                sibling_loader: false,
                disability_loader: false,
                fields1:[],
                fields2:[]
            };

        },
        watch: {
            learner(newVal, oldVal) {
                if (newVal) {
                    this.getChildDataForProfile();
                    this.getParentDataForProfile();
                    this.getChildCategoryDetails();
                    this.getChildDisabilityDetails();
                    this.getChildSiblingForPhofile();
                }
            }
        },
        computed: {
            // languagesSpoken: {
            //     get() {
            //         return this.editable.languages_spoken
            //             ? this.editable.languages_spoken.split(',')
            //             : [];
            //     },
            //     set(value) {
            //         this.editable.languages_spoken = value.join(',');
            //     }
            // }
        },

        methods: {
            allowOnlyText(e) {
                const char = String.fromCharCode(e.keyCode);

                // Allow only A-Z or a-z
                const pattern = /^[A-Za-z]+$/;

                if (!pattern.test(char)) {
                    e.preventDefault(); // Block digit / special char
                }
            },
            onlyLettersAndSpace(field) {
                if (!field.value) return;
                const clean = field.value.replace(/[^A-Za-z\s]/g, '');
                if (field.value !== clean) {
                    this.$nextTick(() => {
                        field.value = clean;
                    });
                }
            },

            restrictToLettersOnly(e) {
                // Allow: Backspace, Delete, Tab, Escape, Enter, Home, End, Arrow keys, Space
                const allowed = [
                    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                    'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
                ];

                // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
                if (e.ctrlKey || e.metaKey) {
                    if (['a', 'c', 'v', 'x', 'z'].includes(e.key.toLowerCase())) {
                        return; // let it happen
                    }
                }

                // Allow letters and space only
                if (!/[A-Za-z\s]/.test(e.key) && !allowed.includes(e.key)) {
                    e.preventDefault();
                }
            },

            cleanPaste(field) {
                setTimeout(() => {
                    const clean = (field.value || '').replace(/[^A-Za-z\s]/g, '');
                    this.$nextTick(() => field.value = clean);
                }, 0);
            },
            deleteAttachment(id) {
                if (!confirm("Are you sure you want to delete this document?")) return;
                this.delete_load = true;



                const data = {
                    learner_id: this.learner,
                    doc_id: id,
                };
                axios
                    .post("/Admission/deleteDocument", data)
                    .then((res) => {
                        this.delete_load = false;
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Document deleted successfully..."); // show snackbar on success
                            this.CategoryDetails.cast_certificate.value = null;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar

                        }
                    })
                    .catch((error) => {
                        this.delete_load = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_load = false;
                    });
            },
            getItemsForField(key) {
                switch (key) {
                    case "quota": return this.quotaList;
                    case "category": return this.categoryList;
                    case "domacile": return this.domacile_list;
                    case "religion": return this.religion_list;
                    case "cast": return this.cast_list;
                    case "sub_caste": return this.sub_cast_list;
                    case "actual_category" : return this.categoryList;
                    default: return [];
                }
            },
            getChildCategoryDetails() {
                const data = { learner: this.learner }
                axios.post("/parent/getChildCategoryDetails", data).then((res) => {
                    if (res.data.flag == "YES") {
                        this.sub_cast_list = res.data.sub_cast_list;
                        this.religion_list = res.data.religion_list;
                        this.cast_list = res.data.cast_list;
                        this.domacile_list = res.data.domacile_list;
                        this.quotaList = res.data.quotaList;
                        this.categoryList = res.data.categoryList;
                        this.CategoryDetails = res.data.CategoryDetails;
                        this.ldid = res.data.ldid;

                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                    this.fetch_loader = false;
                });
            },
            saveChildCategoryDetails() {
                // ✅ Validate only non-file fields
                for (const key in this.CategoryDetails) {
                    const field = this.CategoryDetails[key];
                    if (!field.isactive || !field.required) continue;

                    // For file fields → check newFile (user selected file) OR existing value (already uploaded)
                    if (field.type === "file") {
                        const hasExistingFile = field.value && field.value.path;
                        const hasNewFile = field.newFile instanceof File;
                        if (!hasExistingFile && !hasNewFile) {
                            this.showSnackbar("error", `${field.displayName} is required`);
                            return;
                        }
                    }
                    // Normal fields
                    else if (!field.value || field.value === "") {
                        this.showSnackbar("error", `${field.displayName} is required`);
                        return;
                    }
                }

                this.category_loader = true;

                // 🔑 Flatten payload
                const payload = { learner_id: this.learner };

                for (const key in this.CategoryDetails) {
                    const field = this.CategoryDetails[key];
                    if (field && "value" in field) {
                        payload[key] = field.value;
                    }
                }

                axios.post("/parent/saveChildCategoryDetails", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            // ✅ Use snackbar message if available, else fallback
                            this.showSnackbar("success", res.data.snackbar || "Category Details Updated Successfully");

                        } else {
                            this.showSnackbar("error", res.data.status || res.data.snackbar || "Something went wrong!");
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("error", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.category_loader = false;
                    });
            },

            uploadCasteCertificate() {
                // ✅ Proper validation
                if (!this.CategoryDetails.cast_certificate || !this.CategoryDetails.cast_certificate.newFile) {
                    this.showSnackbar("error", "Please select a file");
                    return;
                }

                let formData = new FormData();
                formData.append("file", this.CategoryDetails.cast_certificate.newFile);
                formData.append("ldid", this.ldid);

                this.upload_image_loader = true;

                axios.post("/Admission/saveUploadCasteCertificate", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "Document uploaded successfully");

                            // ✅ Normalize caste_certificate structure
                            if (res.data.stud_data.cast_certificate) {
                                this.CategoryDetails.cast_certificate.value = {
                                    id: res.data.stud_data.doc_id,
                                    path: res.data.stud_data.cast_certificate
                                };
                            } else {
                                this.CategoryDetails.cast_certificate.value = null;
                            }

                            this.stud_data = res.data.stud_data;

                        } else if (res.data.status === "NOF") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.stud_data = res.data.stud_data;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.upload_image_loader = false;
                        // ✅ reset file input after upload
                        this.CategoryDetails.cast_certificate.newFile = null;
                    });
            },

            blockNonLetters(e) {
                const char = String.fromCharCode(e.keyCode || e.which);
                // Allow only letters and space
                if (!/^[a-zA-Z\s]$/.test(char)) {
                    e.preventDefault();
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getChildDataForProfile() {

                const data = {
                    learner: this.learner
                }
                axios
                    .post("/parent/getChildDataForProfile", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {

                            // this.readonly = res.data.readonly;
                            // this.editable = res.data.editable;
                            this.fields = res.data.fields;
                            this.language_list = res.data.language_list;
                            this.family_type_list = res.data.family_type_list;
                            this.learner_id = res.data.learner_id;
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                        this.fetch_loader = false;
                    })

            },
            getTextFieldRules(field) {
                const rules = [];
                if (field.required) {
                    rules.push(v => !!v || `${field.label} is required`);
                }
                return rules;
            },
            getNumberFieldRules(fieldName, isRequired) {
                const rules = [];

                // Only add required rule if the field is marked as required
                if (isRequired) {
                    rules.push(v => !!v || `${fieldName.replace(/_/g, ' ')} is required`);
                }

                // Specific rules for Aadhaar number (12 digits)
                if (fieldName.includes('aadhar_no')) {
                    rules.push(v => !v || v.toString().length === 12 || `${fieldName.replace(/_/g, ' ')} must be exactly 12 digits`);
                    rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
                }

                // Specific rules for contact number (10 digits)
                if (fieldName.includes('contact_no')) {
                    rules.push(v => !v || v.toString().length === 10 || `${fieldName.replace(/_/g, ' ')} must be exactly 10 digits`);
                    rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
                }

                // Optional: Add rule for income to ensure it's positive
                if (fieldName.includes('income')) {
                    rules.push(v => !v || v >= 0 || `${fieldName.replace(/_/g, ' ')} must be a positive number`);
                    rules.push(v => !v || /^[0-9]+$/.test(v) || `${fieldName.replace(/_/g, ' ')} must contain only numbers`);
                }

                return rules;
            },
            restrictToNumbers(event) {
                const charCode = event.charCode || event.keyCode;
                const fieldName = event.target.name || 'unknown';
                // console.log(`Keypress for ${fieldName}: charCode=${charCode}`);
                // Allow digits (0-9), backspace (8), tab (9), enter (13), arrow keys (37-40)
                if (
                    (charCode >= 48 && charCode <= 57) || // 0-9
                    charCode === 8 || // Backspace
                    charCode === 9 || // Tab
                    charCode === 13 || // Enter
                    (charCode >= 37 && charCode <= 40) // Arrow keys
                ) {
                    return true;
                }
                event.preventDefault();
            },

            getParentDataForProfile() {
                const data = { learner: this.learner };

                axios.post("/parent/getParentDataForProfile", data)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            // console.log("Parent Details Response:", JSON.stringify(res.data.parentDetails, null, 2));

                            const motherData = res.data.parentDetails.mother || { present: false, fields: [] };
                            const fatherData = res.data.parentDetails.father || { present: false, fields: [] };

                            const motherFields = Array.isArray(motherData.fields) ? motherData.fields : [];
                            const fatherFields = Array.isArray(fatherData.fields) ? fatherData.fields : [];

                            this.$set(this, 'parentDetails', {
                                learner_id: res.data.parentDetails.learner_id || '', // Default learner_id to empty string
                                mother: {
                                    present: motherData.present || false, // Default to false if undefined
                                    fields: motherFields.map(field => ({
                                        ...field,
                                        value: field.value || '' // Ensure field.value is a string
                                    })),
                                    photo: null, // Initialize photo as null
                                    old_photo: motherFields.find(f => f.field_name === 'mother_relative_photo_file')
                                        ? motherFields.find(f => f.field_name === 'mother_relative_photo_file').value
                                        : null // Safely get old_photo or null
                                },
                                father: {
                                    present: fatherData.present || false, // Default to false if undefined
                                    fields: fatherFields.map(field => ({
                                        ...field,
                                        value: field.value || '' // Ensure field.value is a string
                                    })),
                                    photo: null, // Initialize photo as null
                                    old_photo: fatherFields.find(f => f.field_name === 'father_relative_photo_file')
                                        ? fatherFields.find(f => f.field_name === 'father_relative_photo_file').value
                                        : null // Safely get old_photo or null
                                }
                            });
                        } else {
                            // Show error message from server
                            this.showSnackbar("error", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        // Log and show error if API call fails
                        console.error("Error fetching parent data:", error);
                        this.showSnackbar("error", "Failed to fetch parent data.");
                    });
            },
            saveParentData(type) {
                let fieldsToSave = [];
                let photoField = null;
                let isPhotoUpload = false;
                let parentType = type.replace('_Upload', '');

                // Determine fields to validate
                if (type === 'Mother' || type === 'Mother_Upload') {
                    fieldsToSave = this.parentDetails.mother.fields;
                    photoField = this.parentDetails.mother.photo;
                    isPhotoUpload = type === 'Mother_Upload';
                } else if (type === 'Father' || type === 'Father_Upload') {
                    fieldsToSave = this.parentDetails.father.fields;
                    photoField = this.parentDetails.father.photo;
                    isPhotoUpload = type === 'Father_Upload';
                }

                // Debug: Log field values
                // console.log(`Fields for ${parentType}:`, fieldsToSave.map(f => ({ name: f.field_name, value: f.value, required: f.required })));

                // Find full_name field to determine if individual name fields can be skipped
                const fullNameField = fieldsToSave.find(f => f.field_name === `${parentType.toLowerCase()}_full_name`);
                const nameFieldsToSkip = [
                    `${parentType.toLowerCase()}_first_name`,
                    `${parentType.toLowerCase()}_middle_name`,
                    `${parentType.toLowerCase()}_last_name`,
                    `${parentType.toLowerCase()}_full_name_as_per_doc`
                ];

                // Validate required fields
                for (let field of fieldsToSave) {
                    if (field.required && !isPhotoUpload && field.input_type !== 'file') {
                        field.value = field.value ? String(field.value).trim() : '';
                        // Skip validation for name fields if full_name is provided
                        if (fullNameField && fullNameField.value && nameFieldsToSkip.includes(field.field_name)) {
                            continue;
                        }
                        if (!field.value) {
                            const action = field.input_type === 'date' || field.input_type === 'select' ? 'select' : 'enter';
                            this.showSnackbar("error", `Please ${action} ${field.label}`);
                            return;
                        }
                    }
                    // Specific validations
                    if (field.field_name.endsWith('aadhar_no') && field.value) {
                        if (field.value.toString().length !== 12) {
                            this.showSnackbar("error", `${field.label} must be exactly 12 digits`);
                            return;
                        }
                    }
                    if (field.field_name.endsWith('contact_no') && field.value) {
                        if (field.value.toString().length !== 10) {
                            this.showSnackbar("error", `${field.label} must be exactly 10 digits`);
                            return;
                        }
                    }
                    if (field.field_name.endsWith('email') && field.value) {
                        if (!/.+@.+\..+/.test(field.value)) {
                            this.showSnackbar("error", `Please enter a valid ${field.label}`);
                            return;
                        }
                    }
                    if (field.field_name.endsWith('income') && field.value) {
                        if (field.value < 0) {
                            this.showSnackbar("error", `${field.label} must be a positive number`);
                            return;
                        }
                    }
                }

                // Validate photo if required
                const photoFieldConfig = fieldsToSave.find(f => f.field_name === `${parentType.toLowerCase()}_relative_photo_file`);
                if (photoFieldConfig && photoFieldConfig.required && isPhotoUpload && !photoField) {
                    this.showSnackbar("error", `Please select a photo for ${parentType}`);
                    return;
                }

                // Prepare FormData
                let formData = new FormData();
                formData.append('learner_id', this.learner);

                // Append all mother and father fields
                this.parentDetails.mother.fields.forEach(field => {
                    if (field.input_type !== 'file') {
                        formData.append(field.field_name, field.value ? String(field.value).trim() : '');
                    }
                });
                this.parentDetails.father.fields.forEach(field => {
                    if (field.input_type !== 'file') {
                        formData.append(field.field_name, field.value ? String(field.value).trim() : '');
                    }
                });

                // Append photo if uploading
                if (isPhotoUpload && photoField) {
                    formData.append(`${parentType.toLowerCase()}_photo`, photoField);
                }

                // Debug: Log FormData
                for (let [key, value] of formData.entries()) {
                    // console.log(`FormData: ${key} = ${value}`);
                }

                this.save_loader = true;
                axios
                    .post("/parent/saveParentDataForProfile", formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            if (isPhotoUpload) {
                                if (type === 'Mother_Upload') {
                                    this.$set(this.parentDetails.mother, 'old_photo',
                                        res.data.parentDetails.mother.fields.find(f => f.field_name === 'mother_relative_photo_file').value || null);
                                    this.$set(this.parentDetails.mother, 'photo', null);
                                    this.previewMotherPhoto = '';
                                } else if (type === 'Father_Upload') {
                                    this.$set(this.parentDetails.father, 'old_photo',
                                        res.data.parentDetails.father.fields.find(f => f.field_name === 'father_relative_photo_file').value || null);
                                    this.$set(this.parentDetails.father, 'photo', null);
                                    this.previewFatherPhoto = '';
                                }
                            }
                            this.getParentDataForProfile();
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("error", "Something went wrong!");
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },

            getChildBirthDetails() {
                const data = {
                    learner: this.learner
                }
                axios
                    .post("/parent/getChildBirthDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.birthcountry_list = res.data.birthcountry_list
                            this.birthDetails = res.data.birthDetails;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("error", res.data.snackbar);
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                        this.fetch_loader = false;
                    })
                // .catch((error) => {
                //     this.onerror(error);
                //     this.fetch_loader = false;
                // })
                // .finally(() => {
                //     this.fetch_loader = false;
                // });
            },
            getChildSiblingForPhofile() {
                const data = {
                    learner: this.learner
                };

                axios.post("/parent/getSiblingForProfile", data)
                    .then((res) => {
                        const response = res.data;

                        if (response.flag === "YES") {
                            this.sibling1 = response.sibling1 || {};
                            this.sibling2 = response.sibling2 || {};
                            this.standard_list = response.standard_list || [];
                            this.fields1 = res.data.fields1;
                            this.fields2 = res.data.fields2;
                            this.learner_id = res.data.learner_id;
                        } else {
                            this.showSnackbar("error", response.snackbar);
                        }

                        this.fetch_loader = false;
                    })
                    .catch((err) => {
                        console.error("Error fetching sibling data:", err);
                        this.showSnackbar("error", "Failed to fetch sibling data.");
                        this.fetch_loader = false;
                    });
            },

            getChildDisabilityDetails() {

                const data = {
                    learner: this.learner
                }
                axios
                    .post("/parent/getChildDisabilityDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.PhysicallyChallenged = res.data.PhysicallyChallenged;
                            this.disability_type_list = res.data.disability_type_list;
                        } else {
                            this.showSnackbar("error", "Something went wrong...");
                        }
                        this.fetch_loader = false;
                    })

            },
            savePersonal() {
                for (let field of this.fields) {
                    if (field.required && field.iseditable) {
                        if (
                            field.value == null ||
                            field.value === '' ||
                            (Array.isArray(field.value) && field.value.length === 0)
                        ) {
                            const action =
                                field.input_type === 'date' || field.input_type === 'select'
                                    ? 'select'
                                    : 'enter';
                            this.showSnackbar("error", `Please ${action} ${field.label}`);
                            return;
                        }
                    }

                    if (field.field_name === 'aadhar_no' && field.value && field.iseditable) {
                        if (field.value.toString().length !== 12) {
                            this.showSnackbar("error", "Aadhaar No. must be exactly 12 digits");
                            return;
                        }
                    }
                    if (field.field_name === 'apaar_id' && field.value) {
                        if (field.value.toString().length !== 12) {
                            this.showSnackbar("error", "Apaar Id must be exactly 12 digits");
                            return;
                        }
                    }
                    if (field.field_name === 'pen' && field.value) {
                        if (field.value.toString().length !== 11) {
                            this.showSnackbar("error", "PEN must be exactly 11 digits");
                            return;
                        }
                    }
                }

                const fieldData = this.fields.reduce((obj, field) => {
                    if (Array.isArray(field.value)) {
                        obj[field.field_name] = field.value.join(",");
                    } else {
                        obj[field.field_name] = field.value;
                    }
                    return obj;
                }, {});


                const payload = {
                    learner_id: this.learner_id,
                    ...fieldData
                };

                this.save_loader = true;
                axios
                    .post("/parent/saveChildDataForProfile", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            this.getChildDataForProfile();
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("error", "Something went wrong!");
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },



            saveBirthDetails() {
                // Validation dynamically
                for (let key in this.birthDetails) {
                    let f = this.birthDetails[key];
                    if (f.required && (!f.value || f.value === "")) {
                        this.showSnackbar("error", `Please Enter ${f.displayName}`);
                        return;
                    }
                }

                this.birth_loader = true;

                // send learner_id + field values only
                let payload = {
                    learner_id: this.learner_id,
                };
                for (let key in this.birthDetails) {
                    payload[key] = this.birthDetails[key].value;
                }

                axios.post("/parent/saveChildBirthDetails", payload)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                    })
                    .finally(() => {
                        this.birth_loader = false;
                    });
            },

            saveSiblingProfile() {
                // Generic validations
                for (let field of this.fields1) {
                    if (field.required) {
                        if (
                            field.value == null ||
                            field.value === '' ||
                            (Array.isArray(field.value) && field.value.length === 0)
                        ) {
                            const action =
                                field.input_type === 'date' || field.input_type === 'select'
                                    ? 'select'
                                    : 'enter';
                            this.showSnackbar("error", `Please ${action} ${field.label}`);
                            return;
                        }
                    }

                }

                for (let field of this.fields2) {
                    if (field.required) {
                        if (
                            field.value == null ||
                            field.value === '' ||
                            (Array.isArray(field.value) && field.value.length === 0)
                        ) {
                            const action =
                                field.input_type === 'date' || field.input_type === 'select'
                                    ? 'select'
                                    : 'enter';
                            this.showSnackbar("error", `Please ${action} ${field.label}`);
                            return;
                        }
                    }

                }

                // ✅ Convert fields array → object with field_name: value
                const fieldData1 = this.fields1.reduce((obj, field) => {
                    if (Array.isArray(field.value)) {
                        // join multiple selections into comma-separated string
                        obj[field.field_name] = field.value.join(",");
                    } else {
                        obj[field.field_name] = field.value;
                    }
                    return obj;
                }, {});

                const fieldData2 = this.fields2.reduce((obj, field) => {
                    if (Array.isArray(field.value)) {
                        // join multiple selections into comma-separated string
                        obj[field.field_name] = field.value.join(",");
                    } else {
                        obj[field.field_name] = field.value;
                    }
                    return obj;
                }, {});

                const payload = {
                    learner: this.learner,
                    fields1: this.fields1,
                    fields2: this.fields2,
                    ...fieldData1,
                    ...fieldData2

                };
                this.sibling_loader = true;
                axios.post("/parent/saveSiblingForProfile", payload)
                    .then((res) => {
                        const response = res.data;

                        if (response.flag === "YES") {
                            this.showSnackbar("success", response.snackbar || "Sibling info saved.");
                            this.sibling_loader = false;
                        } else {
                            this.showSnackbar("error", response.snackbar || "Something went wrong.");
                            this.sibling_loader = false;
                        }
                    })
                    .catch((err) => {
                        console.error("Save error:", err);
                        this.showSnackbar("error", "Failed to save sibling info.");
                        this.sibling_loader = false;
                    });
            },
            saveChildDisabilityDetails() {
                this.disability_loader = true;

                const payload = {
                    learner_id: this.learner,
                    is_physically_disabled: this.PhysicallyChallenged.is_physically_disabled.value
                };

                // ✅ Validation dynamically
                for (let key in this.PhysicallyChallenged) {
                    let f = this.PhysicallyChallenged[key];

                    if (f.required) {
                        // Always check is_physically_disabled

                        if (key === "is_physically_disabled" && (f.value === null || f.value === "")) {
                            this.showSnackbar("error", `Please Select ${f.displayName}`);
                            this.disability_loader = false;
                            return;
                        }

                        // Other fields only if disabled = true
                        if (payload.is_physically_disabled === true && (f.value === null || f.value === "")) {
                            this.showSnackbar("error", `Please Enter ${f.displayName}`);
                            this.disability_loader = false;
                            return;
                        }
                    }
                }

                // ✅ If disabled = true, include extra fields
                if (payload.is_physically_disabled === true) {
                    payload.physicaldisabilitytype = this.PhysicallyChallenged.physicaldisabilitytype.value;
                    payload.disability_percentage = this.PhysicallyChallenged.disability_percentage.value;
                }

                // ✅ API call
                axios.post("/parent/saveChildDisabilityDetails", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.showSnackbar("success", "Disability Details Updated Successfully");
                        } else {
                            this.showSnackbar("error", res.data.snackbar || "Unable to save");
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("error", "Server error occurred");
                    })
                    .finally(() => {
                        this.disability_loader = false;
                    });
            },

            validateFatherPhoto(file) {
                this.photoValidationError = '';
                this.previewFatherPhoto = '';
                if (!file) {
                    this.parentDetails.father.photo = null;
                    return;
                }
                const allowedTypes = ['image/jpeg', 'image/png'];
                const maxSize = 500 * 1024; // 500KB
                const maxWidth = 350;
                const maxHeight = 450;

                if (!allowedTypes.includes(file.type)) {
                    this.photoValidationError = 'Only JPG and PNG formats are allowed.';
                    this.parentDetails.father.photo = null;
                    return;
                }
                if (file.size > maxSize) {
                    this.photoValidationError = 'File size should be 500KB or less.';
                    this.parentDetails.father.photo = null;
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewFatherPhoto = e.target.result; // Show preview immediately
                    const img = new Image();
                    img.onload = () => {
                        if (img.width > maxWidth || img.height > maxHeight) {
                            this.photoValidationError = `Image resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
                            this.parentDetails.father.photo = null;
                        }
                    };
                    img.onerror = () => {
                        this.photoValidationError = 'Failed to load image for validation.';
                        this.parentDetails.father.photo = null;
                        this.previewFatherPhoto = '';
                    };
                    img.src = e.target.result;
                };
                reader.onerror = () => {
                    this.photoValidationError = 'Failed to read the file.';
                    this.parentDetails.father.photo = null;
                    this.previewFatherPhoto = '';
                };
                reader.readAsDataURL(file);
            },
            validateMotherPhoto(file) {
                this.photoValidationErrorMother = '';
                this.previewMotherPhoto = '';
                if (!file) {
                    this.parentDetails.mother.photo = null;
                    return;
                }
                const allowedTypes = ['image/jpeg', 'image/png'];
                const maxSize = 500 * 1024; // 500KB
                const maxWidth = 350;
                const maxHeight = 450;

                if (!allowedTypes.includes(file.type)) {
                    this.photoValidationErrorMother = 'Only JPG and PNG formats are allowed.';
                    this.parentDetails.mother.photo = null;
                    return;
                }
                if (file.size > maxSize) {
                    this.photoValidationErrorMother = 'File size should be 500KB or less.';
                    this.parentDetails.mother.photo = null;
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewMotherPhoto = e.target.result; // Show preview immediately
                    const img = new Image();
                    img.onload = () => {
                        if (img.width > maxWidth || img.height > maxHeight) {
                            this.photoValidationErrorMother = `Image resolution must not exceed ${maxWidth}x${maxHeight} pixels.`;
                            this.parentDetails.mother.photo = null;
                        }
                    };
                    img.onerror = () => {
                        this.photoValidationErrorMother = 'Failed to load image for validation.';
                        this.parentDetails.mother.photo = null;
                        this.previewMotherPhoto = '';
                    };
                    img.src = e.target.result;
                };
                reader.onerror = () => {
                    this.photoValidationErrorMother = 'Failed to read the file.';
                    this.parentDetails.mother.photo = null;
                    this.previewMotherPhoto = '';
                };
                reader.readAsDataURL(file);
            },


        },
        mounted() {
            this.learner = localStorage.getItem("learner_for_profile");
            if (this.learner) {
                this.getChildDataForProfile();
                this.getParentDataForProfile();
                this.getChildBirthDetails();
                this.getChildCategoryDetails();
                this.getChildDisabilityDetails();
                this.getChildSiblingForPhofile();
            }

            this.awspath = localStorage.getItem("awspath");


        },
    };
</script>

<style scoped>
    .custom-header {
        background: linear-gradient(to right, #FFE0B2, #FFCCBC);
        color: black !important;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
    }

    .sibling-table-container {
        width: 100%;
        overflow-x: auto;
    }

    .sibling-table {
        width: 100%;
        min-width: 800px;
        /* prevents breaking table structure */
        border: 1px solid lightgrey;
        border-collapse: collapse;
        text-align: center;
    }

    .sibling-table td,
    .sibling-table th {
        padding: 8px;
        vertical-align: middle !important;
        border: 1px solid lightgray;
        white-space: nowrap;
    }


    .button-77 {
        /* background-color: initial; */
        /* border-style: none; */
        color: #fff;
        cursor: pointer;
        /* font-size: 16px; */
        font-weight: 800;
        vertical-align: middle;
        z-index: 0;
        /* padding: 19px 16px; */
    }

    /* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

    .button-77:before,
    .button-77:after {
        border-radius: 80px;
    }

    .button-77:before {
        background-color: rgba(249, 58, 19, .32);
        content: "";
    }

    .button-77:after {
        /* background-color: initial; */
        background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
        bottom: 4px;
        content: "";
        display: block;
        left: 4px;
        overflow: hidden;
        position: absolute;
        right: 4px;
        top: 4px;
        transition: all 100ms ease-out;
        z-index: -1;
    }

    .button-77:hover:not(:disabled):after {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        transition-timing-function: ease-in;
    }

    .button-77:active:not(:disabled) {
        color: #ccc;
    }

    .button-77:active:not(:disabled):after {
        background-image: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
        bottom: 4px;
        left: 4px;
        right: 4px;
        top: 4px;
    }

    .button-77:disabled {
        cursor: default;
        opacity: .24;
    }

    .custom-toolbar {
        background: linear-gradient(to right, #a8edea, #e4d0ff);
        background: linear-gradient(to right, #a8edea, #e4d0ff);
    }

    .main-card {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .custom-tabs {
        background: linear-gradient(to right, #b2d8f7, #f4d1f4);
        border-radius: 30px;
        padding: 2px;
        min-height: 50px;
    }

    .custom-tab {
        font-weight: normal;
        color: black;
        text-transform: uppercase;
        font-size: 14px;
        min-height: 40px;
        border-radius: 0;
    }

    .first-tab {
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
    }

    .last-tab {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
    }

    .active-tab {
        background: white !important;
        color: black !important;
        font-weight: bold !important;
    }

    .under-development {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        background-color: #f5f6fa;
        text-align: center;
    }

    .content {
        padding: 20px;
        border: 2px dashed #ccc;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

    h1 {
        color: #333;
        margin-top: 20px;
        font-size: 24px;
    }

    p {
        color: #666;
        font-size: 16px;
    }
</style>